export interface Waste {
  type: WasteType;
  kgOfPlastic?: number;
  kgOfNonPlastic?: number;
}
export enum WasteType {
  Normal = 'normal',
  ZeroWaste = 'zeroWaste',
  SpecialAttention = 'specialAttention',
  /** The user typed their own quantities; every other type uses server-side averages. */
  Specific = 'specific',
}
